const Header = ({ src, type, label }) => (
  <div className="coverage-header">
    <img className="coverage-header__icon" src={src} alt={type} />
    <span className="coverage-header__label">{label}</span>
  </div>
);

export default Header;
